var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafetyIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 17.75V14H14.75V26H19.292C19.538 26.3127 19.835 26.5887 20.177 26.8137L21.2195 27.5H13.9948C13.7974 27.5 13.608 27.4216 13.4684 27.2821C13.3288 27.1426 13.2502 26.9534 13.25 26.756V13.244C13.25 12.8413 13.5867 12.5 14.0015 12.5H22.2477L26.75 17V17.75H21.5ZM20 19.25H26.75V23.7118C26.75 24.4542 26.3742 25.1487 25.748 25.5605L23.375 27.1235L21.002 25.5605C20.695 25.3596 20.4427 25.0855 20.2678 24.763C20.0929 24.4404 20.0009 24.0794 20 23.7125V19.25ZM21.5 23.7118C21.5 23.9487 21.6215 24.1722 21.827 24.308L23.375 25.328L24.923 24.308C25.0227 24.2435 25.1048 24.1553 25.1619 24.0512C25.2189 23.9471 25.2492 23.8305 25.25 23.7118V20.75H21.5V23.7118Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyIcon1);
export default __webpack_public_path__ + "static/media/safety_icon1.c2a83e287f7c20a83081b8fb5c45de64.svg";
export { ForwardRef as ReactComponent };